module.exports = __webpack_public_path__ + "static/media/b-radar.4aa7ee53.png";